import { OnMessageCallback } from 'mqtt';
import { store } from '../../app/store';
import { trackingActions } from './trackingSlice';

export const trackingMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    const { actor, status } = JSON.parse(payload.toString());

    store.dispatch(trackingActions.set_status({ plid: actor, status }));    
};
